import React, { useState } from "react";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_FASTAPI_BASE_URL || process.env.REACT_APP_API_BASE_URL;

const QueryPage = () => {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleInputChange = (e) => {
    setQuery(e.target.value);
  };

  const handleFetchResults = async () => {
    if (!query.trim()) {
      setError("Please enter a valid query.");
      return;
    }

    setLoading(true);
    setError("");
    try {
      let response;
      try {
        response = await axios.post(`${API_BASE_URL}/ask`, { query });
      } catch (primaryError) {
        response = await axios.post(`${API_BASE_URL}/api/ask`, { query });
      }
      setResults(response.data.cases || []);
    } catch (err) {
      const status = err?.response?.status;
      setError(
        status
          ? `Failed to fetch results (HTTP ${status}).`
          : "Failed to fetch results. Please check backend URL/CORS."
      );
    }
    setLoading(false);
  };

  return (
    <div className="h-screen p-6 flex flex-col gap-4">
      <div className="bg-gradient-to-b from-white/70 via-white/40 to-white/30 backdrop-blur-xl border border-white/40 shadow-[0_10px_25px_rgba(0,0,0,0.08)] rounded-3xl px-6 py-4">
        <h1 className="text-2xl md:text-3xl font-semibold text-gray-800">Available Documents</h1>
        <p className="text-gray-600 mt-1">Find relevant cases and browse document matches quickly.</p>
      </div>

      <div className="flex-1 min-h-0 bg-gradient-to-b from-white/70 via-white/40 to-white/30 backdrop-blur-xl border border-white/40 shadow-[0_10px_25px_rgba(0,0,0,0.08)] rounded-3xl p-4 md:p-6 flex flex-col">
        <div className="grid grid-cols-1 md:grid-cols-[1fr_auto] gap-3 pb-4 border-b border-gray-200">
          <input
            type="text"
            className="w-full px-4 py-3 rounded-xl border border-gray-300 bg-white/80 focus:outline-none focus:ring-2 focus:ring-[#FF7F50] focus:border-transparent"
            placeholder="Enter your cases that you want to search"
            value={query}
            onChange={handleInputChange}
          />
          <button
            className="bg-gradient-to-r from-orange-400 to-orange-600 text-white px-6 py-3 rounded-xl font-medium hover:from-orange-500 hover:to-orange-700 focus:outline-none focus:ring-2 focus:ring-[#FF8A65] focus:ring-opacity-50"
            onClick={handleFetchResults}
            disabled={loading}
          >
            {loading ? "Fetching..." : "Submit"}
          </button>
        </div>

        {error && <p className="text-red-500 mt-3">{error}</p>}

        <div className="flex-1 min-h-0 overflow-y-auto pt-4 space-y-4">
          {results.length === 0 ? (
            <p className="text-gray-500 text-center mt-8">No results yet. Try searching for a case.</p>
          ) : (
            results.map((result) => (
              <div
                key={result.case_id}
                className="bg-white/85 border border-orange-100 shadow-sm rounded-2xl p-4 hover:border-orange-200 transition-colors"
              >
                <p className="text-sm text-gray-700 mb-1">
                  {result.court} | {new Date(result.date).toLocaleDateString()}
                </p>
                <p className="text-gray-800">{result.description}</p>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default QueryPage;
